import * as React from 'react';
import RSelect, { Theme } from 'react-select';

const overrideOptionFontWeight = (
  styles: React.CSSProperties
): React.CSSProperties => {
  return { ...styles, fontWeight: 300 };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Select = (props: any): React.ReactElement => {
  return (
    <div style={props?.style as React.CSSProperties}>
      <RSelect
        aria-labelledby={props.labelledBy}
        classNamePrefix="react-select"
        {...props}
        styles={{
          option: (base: React.CSSProperties, state: any): React.CSSProperties => ({
            ...base,
            ...(props.styles?.option ? props.styles.option(base, state) : {}),
            color: state.isSelected ? 'var(--color-text)' : base.color,
          }),
          options: overrideOptionFontWeight(props.styles?.options),
          ...props.styles,
          menuPortal: (base: React.CSSProperties): React.CSSProperties => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        theme={(theme: Theme): Theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            ...colors,
          },
        })}
      />
    </div>
  );
};

const colors = {
  /*
   * multiValue(remove)/color:hover
   */
  danger: 'var(--color-react-select-danger)',

  /*
   * multiValue(remove)/backgroundColor(focused)
   * multiValue(remove)/backgroundColor:hover
   */
  dangerLight: 'var(--color-react-select-danger-light)',

  /*
   * control/backgroundColor
   * menu/backgroundColor
   * option/color(selected)
   */
  neutral0: 'var(--color-react-select-neutral-0)',

  /*
   * control/backgroundColor(disabled)
   */
  neutral5: 'var(--color-react-select-neutral-5)',

  /*
   * control/borderColor(disabled)
   * multiValue/backgroundColor
   * indicators(separator)/backgroundColor(disabled)
   */
  neutral10: 'var(--color-react-select-neutral-10)',

  /*
   * control/borderColor
   * option/color(disabled)
   * indicators/color
   * indicators(separator)/backgroundColor
   * indicators(loading)/color
   */
  neutral20: 'var(--color-react-select-neutral-20)',

  /*
   * control/borderColor(focused)
   * control/borderColor:hover
   */
  neutral30: 'var(--color-react-select-neutral-30)',

  /*
   * menu(notice)/color
   * singleValue/color(disabled)
   * indicators/color:hover
   */
  neutral40: 'var(--color-react-select-neutral-40)',

  /*
   * placeholder/color
   */
  // neutral50: 'var(--color-react-select-neutral-50)',
  neutral50: 'var(--color-text)',

  /*
   * indicators/color(focused)
   * indicators(loading)/color(focused)
   */
  neutral60: 'var(--color-react-select-neutral-60)',

  neutral70: 'var(--color-react-select-neutral-70)',

  /*
   * input/color
   * multiValue(label)/color
   * singleValue/color
   * indicators/color(focused)
   * indicators/color:hover(focused)
   */
  // neutral80: 'var(--color-react-select-neutral-50)',
  neutral80: 'var(--color-text)',

  neutral90: 'var(--color-react-select-neutral-90)',

  /*
   * control/boxShadow(focused)
   * control/borderColor(focused)
   * control/borderColor:hover(focused)
   * option/backgroundColor(selected)
   * option/backgroundColor:active(selected)
   */
  primary: 'var(--color-react-select-primary)',

  /*
   * option/backgroundColor(focused)
   */
  primary25: 'var(--color-react-select-primary-25)',

  /*
   * option/backgroundColor:active
   */
  primary50: 'var(--color-react-select-primary-50)',

  primary75: 'var(--color-react-select-primary-75)',
};
